/** Analytics Portal V1 — freshness indicator (Phase 9, plan §11 A8-4).
 * Reports exactly the server's status; never claims "current" on its own. Status is carried by
 * an icon + words, never by colour alone. */
import React from "react";
import { AlertCircle, CheckCircle2, Clock, Loader2, MinusCircle } from "lucide-react";

const STATUS = {
  current: { icon: CheckCircle2, label: "Up to date", tone: "text-[hsl(160_70%_28%)]" },
  delayed: { icon: Clock, label: "Catching up", tone: "text-[hsl(35_85%_32%)]" },
  recalculating: { icon: Loader2, label: "Recalculating", tone: "text-[hsl(35_85%_32%)]", spin: true },
  partial_detail: { icon: AlertCircle, label: "Partial detail", tone: "text-[hsl(35_85%_32%)]" },
  never_processed: { icon: MinusCircle, label: "Not processed yet", tone: "text-muted-foreground" },
};

const shortTime = (iso) => {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString(undefined,
      { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return null; }
};

export const FreshnessIndicator = ({ freshness, timezone }) => {
  if (!freshness?.status) return null;
  const config = STATUS[freshness.status] || STATUS.never_processed;
  const Icon = config.icon;
  const lastEvent = shortTime(freshness.last_event_at);
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs ${config.tone}`}
          data-testid="analytics-freshness" data-status={freshness.status}>
      <Icon className={`h-3.5 w-3.5 ${config.spin ? "animate-spin" : ""}`} aria-hidden="true" />
      <span className="font-[560]">{config.label}</span>
      {lastEvent && (
        <span className="hidden text-muted-foreground sm:inline">
          · last activity {lastEvent}{timezone ? ` (${timezone})` : ""}
        </span>
      )}
    </span>
  );
};
